import { parseAvatarRecord } from '../../utils/ens/avatar/parseAvatarRecord.js';
import { getEnsText } from './getEnsText.js';
export async function getEnsAvatar(client, { blockNumber, blockTag, gatewayUrls, name, universalResolverAddress, }) {
    const record = await getEnsText(client, {
        blockNumber,
        blockTag,
        key: 'avatar',
        name,
        universalResolverAddress,
    });
    if (!record)
        return null;
    try {
        return await parseAvatarRecord(client, { record, gatewayUrls });
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=getEnsAvatar.js.map